import React, { useEffect, useState } from "react";
import './Nav.css'
import Cookies from 'universal-cookie';
import {useNavigate} from 'react-router-dom';
function Nav(){
    const [show , handleShow] = useState(false)
    const navigate = useNavigate()
    const cookies = new Cookies();
    const name = cookies.get('USER')
    useEffect(()=>{
        window.addEventListener("scroll", () => {
            if(window.scrollY >100){
                handleShow(true)
            }
            else handleShow(false)
        });
        // return () => {
        //     window.removeEventListener("scroll");
        // };
    }, [])
    const Logout = () =>{
        window.alert("are you sure about logging out "+ name+"?")
        cookies.set('USER', '', { path: '/' })
        navigate('/')
    }
    return(
    <div className={`nav ${show && "nav_black"}`}>
        <img className="nav_logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/799px-Netflix_2015_logo.svg.png?20190206123158" alt="Netflix Logo" ></img>

        <img className="nav_avatar" src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117" alt="Netflix avatar" onClick={Logout}></img>
    </div>        
    )
}

export default Nav